/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

/**
 * Identifies the different liste recensement options
 */
enum ListeRecensement {
  Recenses = 'recenses',
  RecensesRegularises = 'recenses-regularises',
  NonRecenses = 'non-recenses',
  OmisAdministratif = 'omis-administratif',
}

export default ListeRecensement;
